import {Grid, Typography} from '@mui/material';
import React, {useEffect, useState} from 'react';
import {t} from 'i18next';
import {ReactComponent as BackArrow} from '../../../assests/svg/back-arrow-icon.svg';
import {useSelector} from 'react-redux';
import {RootState} from '../../../redux/store';
import AurButton from '../../common/aur-button/AurButton';
import {ReactComponent as ExportIcon} from '../../../assests/svg/export_icon.svg';
import AurTabMenu from '../../common/aur-tab-menu/AurTabMenu';
import SavedSearchReport from './SavedSearchReport';
import {AdHocSearch} from './AdHocSearch';
import {useNavigate} from 'react-router-dom';
import {
  downloadResponseAsCSV,
  getProjectReportFileName,
} from '../../../utils/utils';
import AurLoadingIndicator from '../../common/aur-loading-indicator/AurLoadingIndictor';
import {exportSearchReport} from '../../../api/EcaManagementService';
import {
  PAGE_NAME,
  usePermissionsByPage,
} from '../../../hooks/permissions/usePermissionsByPage';

type SearchScreenTabTypes = 'Adhoc' | 'SavedSearch';

type SearchTab = {
  index: number;
  content: JSX.Element;
  header: {
    text: string;
  };
  type: SearchScreenTabTypes;
  onClick?: () => void;
};

const SearchReport = () => {
  const navigate = useNavigate();
  const {projectId, selectedProjectName} = useSelector(
    (state: RootState) => state.reports
  );
  const [isClearAllLoading, setIsClearAllLoading] = useState<boolean>(false);
  const {clientId} = useSelector((state: RootState) => state.selectedClient);
  const clientName = useSelector((state: RootState) => state.selectedClient);

  // Initializing the currentTab state to track the active tab
  const [currentTab, setCurrentTab] = useState(0); // Default tab index is 0
  const stringPath = 'eca.savedSearchSelectionDialog.';

  const {hasSavedSearchesPerm} = usePermissionsByPage(
    PAGE_NAME.SEARCH_AUDIT_REPORT
  );

  // Define searchesTab with ReportTab structure
  const [searchesTab, setSearchesTab] = useState<SearchTab[]>([]);

  useEffect(() => {
    setSearchesTab([
      {
        index: 0,
        header: {
          text: t(stringPath + 'adhocSearches'),
        },
        content: <AdHocSearch />,
        type: 'Adhoc',
      },
      ...((hasSavedSearchesPerm
        ? [
            {
              index: 1,
              header: {
                text: t(stringPath + 'savedSearches'),
              },
              content: <SavedSearchReport />,
              type: 'SavedSearch',
            },
          ]
        : []) as SearchTab[]),
    ]);
  }, [hasSavedSearchesPerm]);

  const fetchExportCSVReport = async () => {
    setIsClearAllLoading(true);
    try {
      const pageNameQuery = `&$filter=type eq '${searchesTab[currentTab].type}'`;
      const paramString = `clientId=${clientId}&projectId=${projectId}${pageNameQuery}`;
      const response = await exportSearchReport(paramString);
      downloadResponseAsCSV(
        response,
        getProjectReportFileName(
          selectedProjectName,
          t(stringPath + 'searchAuditReport')
        )
      );
    } catch (error) {
      //
    } finally {
      setIsClearAllLoading(false);
    }
  };

  const handleTabChange = (newTab: number) => {
    setCurrentTab(newTab);
  };
  const goBack = () => {
    navigate(-1);
  };

  return (
    <div className="tag-report-screen search-top">
      <Typography className="typo-text body2_size back-button" onClick={goBack} tabIndex={0}>
        <BackArrow /> {t('tagging-audit-report.backText')}
      </Typography>
      <div className="header-text search-left">
        <Typography className="typo-text body1_size" tabIndex={0}>
          {clientName?.name}
        </Typography>
        <Typography className="typo-text display3_size" tabIndex={0}>
          {selectedProjectName}
        </Typography>
      </div>

      <div className="body-area searchTabReport">
        <Grid
          container
          spacing={2}
          justifyContent="space-between"
          className="export-area"
        >
          <Grid item xs={8} className="search-left">
            <Typography className="typo-text subhead1_size search-left" tabIndex={0} component="h1">
              {t(stringPath + 'searchAuditReport')}
            </Typography>
            <Typography className="typo-text body2_size search-left">
              {t(stringPath + 'searchAuditSub')}
            </Typography>
          </Grid>
          <Grid item xs={4} textAlign="right">
            <AurButton
              data-testid="export-button"
              onClick={() => fetchExportCSVReport()}
              startIcon={
                isClearAllLoading ? (
                  <div className="color-loader">
                    <AurLoadingIndicator
                      size={16}
                      className="progress-icon"
                      aria-hidden="true"
                    />
                  </div>
                ) : (
                  <ExportIcon aria-hidden="true" />
                )
              }
              type="continue"
              size="Medium"
              disabled={isClearAllLoading}
              label={t('tagging-audit-report.exportButtonText')}
              classNames="typo-text buttonMedium_size White-color"
            />
          </Grid>
        </Grid>

        {/* Tab Menu */}
        <AurTabMenu
          headerClasses="typo-text subhead4_size reports-menu-header search-left"
          isResponsive={true}
          width="100%"
          tabs={searchesTab}
          title="report"
          defaultTab={currentTab}
          onTabChange={handleTabChange}
        />
      </div>
    </div>
  );
};

export default SearchReport;
